import React from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';

import { Text } from './text';

import { useTheme } from '@/components/theme-provider';

export interface SegmentedButtonsProps {
	buttons: Array<{
		value: string;
		label: string;
		icon?: string;
		testID?: string;
	}>;
	value: string;
	onValueChange: (value: string) => void;
	multiSelect?: boolean;
	style?: any;
}

export const SegmentedButtons: React.FC<SegmentedButtonsProps> = ({
	buttons,
	value,
	onValueChange,
	multiSelect = false,
	style,
}) => {
	const theme = useTheme();

	return (
		<View style={[styles.container, style]}>
			{buttons.map((button, index) => {
				const isSelected = multiSelect
					? Array.isArray(value) && value.includes(button.value)
					: value === button.value;

				return (
					<TouchableOpacity
						key={button.value}
						testID={button.testID}
						style={[
							styles.button,
							{
								backgroundColor: isSelected ? theme.colors.primary : 'transparent',
								borderColor: theme.colors.outline,
							},
							index === 0 && styles.firstButton,
							index === buttons.length - 1 && styles.lastButton,
						]}
						onPress={() => onValueChange(button.value)}
						activeOpacity={0.7}
					>
						<Text
							variant="labelMedium"
							style={{
								color: isSelected ? theme.colors.onPrimary : theme.colors.onSurface,
							}}
						>
							{button.label}
						</Text>
					</TouchableOpacity>
				);
			})}
		</View>
	);
};

const styles = StyleSheet.create({
	container: {
		flexDirection: 'row',
		borderRadius: 4,
	},
	button: {
		flex: 1,
		paddingVertical: 8,
		paddingHorizontal: 16,
		borderWidth: 1,
		alignItems: 'center',
		justifyContent: 'center',
	},
	firstButton: {
		borderTopLeftRadius: 4,
		borderBottomLeftRadius: 4,
		borderRightWidth: 0,
	},
	lastButton: {
		borderTopRightRadius: 4,
		borderBottomRightRadius: 4,
		borderLeftWidth: 0,
	},
});
